/*
 * Copyright (c) 2024. World Wide Generation Ltd
 */

import { StatusBadge, type StatusBadgeConfig } from '@g17eco/molecules/badge/StatusBadge';
import { GenerationRunStatus } from '@g17eco/types/insights-synthesis';

interface RunStatusBadgeProps {
  status: GenerationRunStatus;
}

const statusConfig: Record<GenerationRunStatus, StatusBadgeConfig> = {
  [GenerationRunStatus.Pending]: { color: 'warning', icon: 'fa-clock', label: 'Pending' },
  [GenerationRunStatus.Processing]: { color: 'primary', icon: 'fa-sync fa-spin', label: 'Processing' },
  [GenerationRunStatus.Completed]: { color: 'success', icon: 'fa-check', label: 'Completed' },
  [GenerationRunStatus.Failed]: { color: 'danger', icon: 'fa-times', label: 'Failed' },
};

export const RunStatusBadge = ({ status }: RunStatusBadgeProps) => {
  const config = statusConfig[status];

  return <StatusBadge config={config} minWidth={100} />;
};
